import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/Logo.png";
import gmail from "../../assets/images/gmail.png";
import lock from "../../assets/images/lock.png";
import Auth from "../../components/Auth/Auth";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { adminLogin } from "../../features/slices/authReducer";
import { toastService } from "../../utils/toastify";
import { getToken } from "../../utils/getToken";
const intialState = {
  email: "",
  password: "",
  isVisible: false,
  errors: {},
  isLoading: false,
};
const Login = () => {
  const [iState, updateState] = useState(intialState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const url = location.state || "/dashboard";
  const { email, password, isVisible, errors, isLoading } = iState;
  const handleChange = (e) => {
    updateState({ ...iState, [e.target.name]: e.target.value, errors: "" });
  };
  useEffect(() => {
    if (getToken("adminLogin")) {
      navigate(url, { replace: true });
    }
  }, []);
  let handleValidation = () => {
    let error = {};
    let formIsValid = true;
    if (!email || !email.trim()) {
      error.emailIdError = " * Email id can't be empty";
      formIsValid = false;
    } else {
      if (!/^.+?@.+?\..+$/.test(email)) {
        error.emailIdError = " * Email format is not valid";
        formIsValid = false;
      }
    }
    if (!password.trim()) {
      error.passwordError = " * Password can't be empty";
      formIsValid = false;
    }
    updateState({
      ...iState,
      errors: error,
    });
    return formIsValid;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let formIsValid = handleValidation(e);
    if (formIsValid) {
      updateState({ ...iState, isLoading: true });
      const data = { email: email?.trim(), password: password?.trim() };
      dispatch(adminLogin(data)).then((data) => {
        if (data?.payload?.code === 200) {
          updateState({
            ...iState,
            isLoading: false,
          });
          return navigate(url, { replace: true });
        } else {
          toastService.error(data?.payload?.message);
          updateState({
            ...iState,
            isLoading: false,
          });
        }
      });
    }
  };
  return (
    <Auth>
      <figure>
        <img src={logo} />
       
      </figure>
      <h2>Sign In</h2>

      <h6>Welcome back, you’ve been missed!</h6>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Username</label>
          <input
            type="email"
            placeholder="Enter Email Address"
            className="form-control"
            name="email"
            value={email}
            onChange={handleChange}
            autoComplete="new-username"
          />
          <span className="Icon">
            <img src={gmail} />
          </span>
          <span style={{ color: "red" }}>{errors.emailIdError}</span>
        </div>
        <div className="form-group">
          <label>Password</label>
          <input
            type={`${isVisible ? "text" : "password"}`}
            placeholder="Enter Password"
            className="form-control"
            name="password"
            value={password}
            onChange={handleChange}
            // autoComplete="new-password"
          />
          <span className="Icon">
            <img src={lock} />
          </span>
          <span
            className="icon"
            onClick={() => {
              updateState((prev) => ({
                ...prev,
                isVisible: !isVisible,
              }));
            }}
          >
            {!isVisible ? (
              <i className="fa fa-eye-slash" aria-hidden="true" />
            ) : (
              <i className="fa fa-eye" aria-hidden="true" />
            )}
          </span>
          <span style={{ color: "red" }}>{errors.passwordError}</span>
        </div>
        <div className="Checkboxs">
          <Link to={"/forgetPassword"}>Forget password?</Link>
        </div>
        <button
          type="submit"
          className="Button"
          disabled={isLoading}
          style={{
            width: "100%",
          }}
        >
          {!isLoading ? (
            "Sign In"
          ) : (
            <>
              <span
                className="spinner-border spinner-border-sm mr-1"
                role="status"
                aria-hidden="true"
              ></span>
              loading...
            </>
          )}
        </button>
      </form>
    </Auth>
  );
};

export default Login;
